import React, { memo, useCallback } from 'react';
import {
  string, func, number, bool,
} from 'prop-types';
import classnames from 'classnames';
import Locale from '@active/react-utils/i18n/Locale';
import Responsive from '@active/react-utils/components/Responsive';
import Button from '@active/react-ui/Button';
import Currency from '../../../Currency';

const OrderSummaryButton = (props) => {
  const {
    paymentMethodType,
    onSubmit, buttonTextId,
    totalAmount, currencyCode,
    currentAmountDue,
    showScrollToOrderSummaryBar,
    className,
    widgetNameSpace,
  } = props;
  const handleClick = useCallback(() => {
    const orderSummaryField = document.querySelector('#checkout_order_summary');
    orderSummaryField.scrollIntoView(true);
  }, []);

  const displayAmount = currentAmountDue !== undefined ? currentAmountDue : totalAmount;
  const classes = classnames({
    'order-summary__button': true,
  }, className);
  return (
    <div className={classes}>
      {paymentMethodType === 'APPLEPAY'
        && <Button noSubmit
          className="apple-pay-button"
          onClick={onSubmit}></Button>
      }
      {paymentMethodType === 'IDEAL'
      && <Button noSubmit
        className="btn-rose-red"
        onClick={onSubmit}>
        <span className="ideal-pay-icon" />
        <Locale id={ buttonTextId || 'checkout.lib.components.orderSummary.payNow'}/>
      </Button>
      }
      <div className={classnames('checkout-paymentmethod-customize-btn', `${widgetNameSpace}-google-customize-btn`, {
        show: paymentMethodType === 'GOOGLEPAY',
      })}></div>
      {paymentMethodType !== 'GOOGLEPAY' && paymentMethodType !== 'APPLEPAY' && paymentMethodType !== 'IDEAL'
    && <Button noSubmit
      className="btn-super"
      onClick={onSubmit}>
      <Responsive not eqAbove="xl">
        <div className="order-summary__button-text"><Locale id="checkout.lib.components.orderSummary.yourPayment" /></div>
        <Currency amount={displayAmount < 0 ? 0 : displayAmount} code={currencyCode} />
      </Responsive>
      <Responsive eqAbove="xl">
        <Locale id={ buttonTextId || 'checkout.lib.components.orderSummary.payNow'}/>
      </Responsive>
    </Button>
      }
      {showScrollToOrderSummaryBar
        && <Responsive not eqAbove="xl">
          <div className="scroll-bar-section">
            <i className="ic-arrow-up-r" onClick={handleClick} />
          </div>
        </Responsive>}
    </div>
  );
};

OrderSummaryButton.propTypes = {
  paymentMethodType: string.isRequired,
  onSubmit: func.isRequired,
  buttonTextId: string,
  totalAmount: number,
  currencyCode: string,
  currentAmountDue: number,
  showScrollToOrderSummaryBar: bool,
  className: string,
};

OrderSummaryButton.defaultProps = {
  showScrollToOrderSummaryBar: true,
};
export default memo(OrderSummaryButton);
